import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../../../common/components/AssetCreationWarning";
import { isCloudAssetDeprecated, isInPreparation } from "../../../../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../../../../common/hooks/useCloudAssetDetails";
import { resolveCloudAssetHref } from "../../../common/resolveCloudAssetHref";
import { CloudSubtitleAssetLanguageForm } from "./CloudSubtitleAssetLanguageForm";

export interface EditCloudVideoAssetSubtitleAsideProps {
    isLabeled?: boolean;
    subtitleId: string;
}

export const EditCloudVideoAssetSubtitleAside: React.FunctionComponent<EditCloudVideoAssetSubtitleAsideProps> = (
    props: EditCloudVideoAssetSubtitleAsideProps
) => {
    const { isLabeled, subtitleId } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { data: assetDetails, isLoading } = useCloudAssetDetails();

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveCloudAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    const areActionsDisabled =
        assetDetails && (isCloudAssetDeprecated(assetDetails) || isInPreparation(assetDetails) || isLoading);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-video-subtitle"
            />
            <Aside type="form" headerText="Edit subtitle" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <CloudSubtitleAssetLanguageForm onDismiss={onClose} onSubmit={onSubmit} subtitleId={subtitleId} />
            </Aside>
        </AuthorizationWrapper>
    );
};
